import { BorrowerProfileState } from '../../interfaces';
import { ProfileAction } from '../actions/profile.action';
import { ActionType } from '../action_types';

const initialState: BorrowerProfileState = { profile: null };

const borrowerProfileReducer = (state = initialState, action: ProfileAction): BorrowerProfileState => {
  switch (action.type) {
    case ActionType.UPDATE_BORROWER_PROFILE:
      return { ...state, profile: action.payload.profile };

    default:
      return { ...state };
  }
};

export default borrowerProfileReducer;
